import { render, staticRenderFns } from "./DuplicateQuestionListItem.vue?vue&type=template&id=878582dc&scoped=true"
import script from "./DuplicateQuestionListItem.vue?vue&type=script&lang=js"
export * from "./DuplicateQuestionListItem.vue?vue&type=script&lang=js"
import style0 from "./DuplicateQuestionListItem.vue?vue&type=style&index=0&id=878582dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878582dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('878582dc')) {
      api.createRecord('878582dc', component.options)
    } else {
      api.reload('878582dc', component.options)
    }
    module.hot.accept("./DuplicateQuestionListItem.vue?vue&type=template&id=878582dc&scoped=true", function () {
      api.rerender('878582dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/DuplicateQuestionListItem.vue"
export default component.exports